import { app } from '../../app.module'
/**
 * 大カテゴリ情報管理用のサービス
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function EditCategoryModal(Restangular, $q) {
  /**
   * getBrandCategories 大カテゴリ一覧を取得
   * @param {object} getOptions 取得オプション(取得対象月、取得対象業種)
   * @return {Object} カテゴリ一覧
   */
  function getBrandCategories() {
    const deferred = $q.defer()

    // データを取得
    Restangular.all('/category/getBrandCategories')
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    return deferred.promise
  }

  /**
   * 大カテゴリを保存
   * @param categoryInfo カテゴリ情報
   * @return サーバーからの結果
   */
  function saveBrandCategory(categoryInfo: {
    saveType: string
    categoryName: string
    beforeSaveCategory: string
    sortNo: number
  }) {
    const deferred = $q.defer()

    const saveUrl = '/category/saveBrandCategory'

    Restangular.all(saveUrl)
      .post(categoryInfo)
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }

  /**
   * 大カテゴリを削除する
   * @param categoryName 大カテゴリ
   * @return サーバーからの結果
   */
  function deleteBrandCategory(categoryName: string) {
    const deleteInfo = {
      categoryName: categoryName,
    }
    const deferred = $q.defer()

    const postUrl = '/category/deleteBrandCategory'

    Restangular.all(postUrl)
      .post(deleteInfo)
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }
  return {
    getBrandCategories: getBrandCategories,
    saveBrandCategory: saveBrandCategory,
    deleteBrandCategory: deleteBrandCategory,
  }
}

/**
 *  大カテゴリ管理モーダル用のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} EditCategoryModal 大カテゴリ管理用のサービス
 * @return {Object} サービスのオブジェクト
 */
function EditCategoryService(EditCategoryModal) {
  return {
    EditCategory: EditCategoryModal,
  }
}

// 大カテゴリ管理モーダル用のサービスを定義
app
  .factory('EditCategoryModal', EditCategoryModal)
  .factory('EditCategoryService', EditCategoryService)
